
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--select condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <ElSelect
        v-bind="contentProps"
        v-on="$listeners"
        :disabled="insetDisabled"
        :filter-method="filterMethod && customFilterMethod"
        :value="checked"
        class="condition-item__content"
        @input="change"
        @blur="customFilterMethod('')"
        @change="customFilterMethod('')"
    >
        <template v-for="item of filterSource">
            <template v-if="item.group && item.children">
                <ElOptionGroup :key="item[valueKey]" :label="item[labelKey]">
                    <template v-for="group of item.children">
                        <ElOption
                            :key="group[valueKey]"
                            :label="group[labelKey]"
                            :value="group[valueKey]"
                        ></ElOption>
                    </template>
                </ElOptionGroup>
            </template>
            <template v-else>
                <ElOption :key="item[valueKey]" :label="item[labelKey]" :value="item[valueKey]"></ElOption>
            </template>
        </template>
    </ElSelect>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else><component :is="getNode(postfix, checked)"></component></template>
    </div>
</ElFormItem>
